import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import qs from "qs";
import { useEffect } from "react";

import { accountAtom } from "shared/lib/account";
import { useRouterReplaceWithSanitizedKeys } from "shared/lib/router";

import { SanitizedUrlKeys } from "./consts";
import type { CommentQueryStringPayload } from "./types";

export const useArticleCommentsActionRedirect = () => {
  const { asPath, pathname, query } = useRouter();
  const replace = useRouterReplaceWithSanitizedKeys();

  const { user } = useAtomValue(accountAtom);

  useEffect(() => {
    const parsedQueryString = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    }) as unknown as CommentQueryStringPayload;

    if (parsedQueryString.comment_login_success !== "1" || !user?.uuid) return;
    void replace(
      SanitizedUrlKeys,
      { pathname, query },
      {
        shallow: true,
      },
    );
  }, [asPath, pathname, query, replace, user?.uuid]);

  return null;
};
